<template lang="pug">
.description(v-nv:scope="'cms-description'", ref="scrollArea", @nv-back="$emit('nv-back')")
  .dummy(v-nv, @nv-up="scroll($event, true)", @nv-down="scroll")
  .content(v-html="content")
</template>

<script>
export default {
  name: "cms-description",
  props: ["content"],
  async mounted() {
    _$.nav.sync("cms-description")
  },
  async activated() {
    _$.nav.sync("cms-description")
  },
  methods: {
    scroll($event, toTop = false) {
      let scrollTop = this.$refs.scrollArea.scrollTop
      switch ($event.type) {
        case "nv-down":
          scrollTop += 100
          break
        case "nv-up":
          scrollTop -= 100
          break
      }
      if (toTop) scrollTop = 0
      $(this.$refs.scrollArea).animate({ scrollTop: scrollTop }, 200)
    }
  }
}
</script>
<style lang="scss" scoped>
.description {
  overflow-x: hidden;
  overflow-y: auto;
  text-align: justify;
  height: 100%;
  position: relative;
  padding-right: 20px;

  .dummy {
    position: absolute;
    visibility: hidden;
  }

  .content {
    padding: 5px 0;
  }
}
</style>
